import { render, staticRenderFns } from "./WelfareAttendanceOfficeFixDialog.vue?vue&type=template&id=2f8a5d02&scoped=true"
import script from "./WelfareAttendanceOfficeFixDialog.vue?vue&type=script&lang=js"
export * from "./WelfareAttendanceOfficeFixDialog.vue?vue&type=script&lang=js"
import style0 from "./WelfareAttendanceOfficeFixDialog.vue?vue&type=style&index=0&id=2f8a5d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a5d02",
  null
  
)

export default component.exports